import { lazy } from 'react'

const tools = [
  {
    slug: 'outreach-utility',
    name: 'Outreach Utility',
    description: 'Research prospects, verify emails, enrich company data, and generate personalized outreach openers.',
    icon: '🔍',
    component: lazy(() => import('./outreach-utility/OutreachUtility')),
  },
  {
    slug: 'email-optimizer',
    name: 'Email Optimizer',
    description: 'Iteratively optimize cold outreach emails against Reply.io quality metrics using Claude AI.',
    icon: '✉️',
    component: lazy(() => import('./email-optimizer/EmailOptimizer')),
  },
]

export default tools

export function getToolBySlug(slug) {
  return tools.find(t => t.slug === slug) || null
}
